import styled from '@emotion/styled';
import { colors } from '@innovationdepartment/proxima-ui';

export const Groups = styled.div`
  display: grid;
  grid-template-columns: 120px 1fr;
  row-gap: 10px;
  column-gap: 16px;
  align-items: start;
`;

export const GroupLabel = styled.div`
  font-size: 13px;
  color: ${colors.neutral60};
  padding-top: 3px;
`;

export const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const FilterChipBox = styled.span<{ tone: 'include' | 'exclude' }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  background: ${({ tone }) => (tone === 'include' ? colors.blue5 : colors.red5)};
  color: ${({ tone }) => (tone === 'include' ? colors.blue70 : colors.red70)};
  white-space: nowrap;
`;

export const ClearChipButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin-right: -4px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: inherit;
  cursor: pointer;
  opacity: 0.6;

  svg {
    font-size: 14px;
  }

  &:hover {
    opacity: 1;
    background: rgba(0, 0, 0, 0.08);
  }
`;
